import React from 'react';
import { Stethoscope, Edit, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';

const ProblemListSection = ({ editedData, isEditing, onToggleEdit, onCancelEdit, onUpdateField }) => {
  return (
    <div className="mb-6">
      <div className="card border-2 border-rose-200 bg-gradient-to-br from-white to-rose-50 shadow-lg">
        <div className="flex items-center justify-between mb-4 pb-2 border-b-2 border-rose-100">
          <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2">
            <Stethoscope size={20} className="text-rose-600" />
            Problem List
          </h2>
          {!isEditing ? (
            <Button onClick={onToggleEdit} className="btn-secondary" data-testid="problem-list-edit-btn">
              <Edit size={16} className="mr-2" />
              Edit
            </Button>
          ) : (
            <Button onClick={onCancelEdit} className="btn-ghost text-red-600" data-testid="problem-list-cancel-btn">
              <X size={16} className="mr-2" />
              Cancel
            </Button>
          )}
        </div>

        {!isEditing ? (
          <div className="p-4 bg-white rounded-lg border border-rose-200">
            {editedData.health_record?.problem_list ? (
              <p className="text-slate-700 whitespace-pre-wrap">{editedData.health_record.problem_list}</p>
            ) : (
              <p className="text-slate-500 italic">No problems listed</p>
            )}
          </div>
        ) : (
          <Textarea
            value={editedData.health_record?.problem_list || ''}
            onChange={(e) => onUpdateField('health_record', 'problem_list', e.target.value)}
            className="w-full"
            rows={6}
            placeholder="List current health problems, diagnoses, or concerns..."
            data-testid="problem-list-textarea"
          />
        )}
      </div>
    </div>
  );
};

export default ProblemListSection;
